import React, { useEffect, useState } from "react";
import { useAuth } from "shared-auth";
import { getErrorPopupTexts } from "component-library";
import { captureExceptionEvent } from "shared-services";
import { ACCOUNT_TYPE_GTM_MAPPING, ErrorCode } from "config/common";
import { SetLoading } from "store/ui/ui.types";
import { GetUserData } from "store/user/user.types";
import { pushToDataLayer } from "app-shell/GoogleTagManager/GoogleTagManager";
import ErrorPopup from "components/Popups/ErrorPopup/ErrorPopup";
import getErrorPopupType from "helpers/getErrorPopupType";

export interface IWithUserStoreProps {
  isUserLoaded: boolean;
}

export interface IWithUserActions {
  getUserData: GetUserData;
  setLoading: SetLoading;
}

export interface IWithUserProps extends IWithUserStoreProps, IWithUserActions {}

export default function withUserData(
  WrappedComponent: React.ComponentType<React.PropsWithChildren<IWithUserProps>>
): React.FC<React.PropsWithChildren<IWithUserProps>> {
  const WithUserData: React.FC<React.PropsWithChildren<IWithUserProps>> = (
    props
  ) => {
    const auth = useAuth();
    const [showError, setShowError] = useState(false);

    const loadUserData = async () => {
      try {
        const user = await props.getUserData();

        pushToDataLayer({
          accountType: ACCOUNT_TYPE_GTM_MAPPING[user.type],
        });
      } catch (e) {
        captureExceptionEvent(e);
        props.setLoading(false);
        setShowError(true);
      }
    };

    useEffect(() => {
      loadUserData();
    }, []);

    if (showError) {
      return (
        <ErrorPopup
          {...getErrorPopupTexts()[getErrorPopupType(ErrorCode.Forbidden)]}
          hidePopup={() => auth.signinRedirect()}
        />
      );
    }

    if (!props.isUserLoaded) {
      return null;
    }

    return <WrappedComponent {...props} />;
  };

  return WithUserData;
}
